import React from "react";
import { RadioGroup, FormControlLabel, Radio, FormControl} from "@mui/material";
import { textColor } from "../../utils/commonstyle";

// Define prop types
interface RadioGroupComponentsProps {
  selectedValue?: string;
  handleRadioChange?: React.ChangeEventHandler<HTMLInputElement>;
  options?: any;
  color?: string;
  direction?: "row" | "column";
  disabled?:boolean
}

const RadioGroupComponents: React.FC<RadioGroupComponentsProps> = ({
  selectedValue,
  handleRadioChange,
  options,
  color = "#FF5C39", // Custom color for selected radio
  direction = "row", // Layout direction, default is horizontal
  disabled = false
}) => (
  <FormControl component="fieldset">
    <RadioGroup
      aria-label="radio-group"
      value={selectedValue}
      onChange={handleRadioChange}
      row={direction === "row"} // Determines layout direction
    >
      {options.map((option:any) => (
        <FormControlLabel
          key={option.value}
          disabled={disabled}
          value={option.value}
          control={
            <Radio
              sx={{
                "&.Mui-checked": {
                  color: color, // Custom color for selected radio button
                },
              }}
            />
          }
          label={option.label}
          sx={{
            color: textColor.fontColor,
          }}
        />
      ))}
    </RadioGroup>
  </FormControl>
);

export default RadioGroupComponents;
